import "phaser";
import { CST } from "../CST";
import { bubblesArray } from "../bubbles";

var bubbles = [];
var timeouts = [];
var points;
var User_ID;
var nonSexistCount;
var nonSexistMissed;
var sexistMissed;
var time_up;
var music;
var pop;
var sound;
var soundOn = 1;

export default class Bubbles extends Phaser.Scene {
  constructor() {
    super(CST.SCENES.BUBBLES);
  }

  init() {
    points = 0;
    nonSexistCount = 0;
    sexistMissed = 0;
    nonSexistMissed = 0;
  }

  create(data) {
    music = this.sound.add("bubbles-music", {
      loop: true,
    });
    pop = this.sound.add("pop-sound");
    music.play();

    this.bubblesArray = bubblesArray;
    this.bubblesArrayShuffled = shuffle(this.bubblesArray);

    User_ID = data.User_ID;

    this.clickSound = this.sound.add("click-sound");
    this.physics.world.setBoundsCollision(true, true, false, false);

    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "buuble-bg"
    );
    this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        "buuble-overlay"
      )
      .setDepth(1.1);
    time_up = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 50,
        "time-up"
      )
      .setDepth(1.3)
      .setVisible(false)
      .setScale(0.45);

    this.menu_btn = this.add
      .image(1425, 55, "menu-button-bubbles")
      .setScale(0.7)
      .setDepth(1.2)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        this.menu_btn.setTexture("menu-button-bubbles");
      })
      .on("pointerup", () => {
        this.clickSound.play();
        this.menu_btn.setTexture("menu-button");
        timeouts.forEach((timeout) => {
          clearTimeout(timeout);
        });
        location.reload();
      });

    sound = this.add
      .sprite(1300, 55, "sound-btn")
      .setFrame(0)
      .setScale(0.7)
      .setDepth(1.2)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        if (soundOn === 1) {
          soundOn = 0;
          sound.setFrame(1);
          this.game.sound.mute = true;
        } else {
          soundOn = 1;
          sound.setFrame(0);
          this.game.sound.mute = false;
        }
      });

    this.pointsText = this.add
      .text(1150, 33, " " + points, CST.TEXTSTYLES.SCORING)
      .setDepth(1.2);

    this.sexistMissedText = this.add
      .text(925, 33, " " + sexistMissed, CST.TEXTSTYLES.SCORING)
      .setDepth(1.2);

    this.timer_text = this.add
      .text(380, 35, "60", CST.TEXTSTYLES.SCORING)
      .setDepth(1.2);
    this.time_left = 60;
    this.time_timer = this.scene.scene.time.now;
    this.time_up = false;

    this.anims.create({
      key: "burst-sprite-sexist",
      frames: this.anims.generateFrameNumbers("burst-sprite-sexist"),
      frameRate: 16,
    });

    this.anims.create({
      key: "burst-sprite-nonsexist",
      frames: this.anims.generateFrameNumbers("burst-sprite-nonsexist"),
      frameRate: 16,
    });

    for (let index = 0; index <= 24; index++) {
      generateBubble(
        this,
        this.cameras.main.width / 2 - 500,
        Math.floor(Math.random() * -60) + 30,
        Math.floor(Math.random() * -15) + 5,
        index
      );
    }

    for (let index = 0; index <= 24; index++) {
      generateBubble(
        this,
        this.cameras.main.width / 2,
        Math.floor(Math.random() * -50) + 25,
        Math.floor(Math.random() * -15) + 5,
        index
      );
    }

    for (let index = 0; index <= 19; index++) {
      generateBubble(
        this,
        this.cameras.main.width / 2 + 500,
        Math.floor(Math.random() * -60) + 30,
        Math.floor(Math.random() * -15) + 5,
        index
      );
    }
  }

  update() {
    this.physics.world.collide(bubbles);
    for (let i = 0; i < bubbles.length - 1; i++) {
      if (bubbles[i].y < 0) {
        if (!bubbles[i].texture.key.includes("nonsexist")) {
          sexistMissed++;
          this.sexistMissedText.text >= 10
            ? (this.sexistMissedText.text = sexistMissed)
            : (this.sexistMissedText.text = " " + sexistMissed);
        } else {
          nonSexistMissed++;
        }
        bubbles[i].destroy();
        bubbles.splice(i, 1);
      }
    }
    updateTimerText(this);
  }
}

function generateBubble(scene, x, gravityX, gravityY, index) {
  let timeout = Math.floor(Math.random() * 6000) + 3000;

  let bubble = scene.physics.add
    .sprite(
      x,
      scene.cameras.main.height / 2 + 750,
      scene.bubblesArrayShuffled[0].sprite
    )
    .setFrame(scene.bubblesArrayShuffled[0].frame)
    .setInteractive({
      useHandCursor: true,
    })
    .on("pointerdown", () => {
      bubble.disableInteractive();
      setTimeout(() => {
        if (bubble.texture.key.includes("nonsexist")) {
          pop.play();
          nonSexistCount++;
          bubble.play("burst-sprite-nonsexist");
        } else {
          pop.play();
          points++;
          scene.pointsText.text >= 10
            ? (scene.pointsText.text = points)
            : (scene.pointsText.text = " " + points);
          bubble.play("burst-sprite-sexist");
        }
        bubble.setGravity(0, 5).setVelocity(0, 0).body.enable = false;
        setTimeout(() => {
          bubble.destroy();
        }, 1000);
      }, 50);
    })
    .setGravity(0, 15)
    .setCollideWorldBounds(true, 1, 0)
    .setBounce(1, 1);

  switch (bubble.texture.key) {
    case "small-sprite-sexist":
      bubble.body.setCircle(77, 31, 30);
      break;
    case "regular-sprite-sexist":
      bubble.body.setCircle(93, 15, 15);
      break;
    case "large-sprite-sexist":
      bubble.body.setCircle(108);
      break;
    case "small-sprite-nonsexist":
      bubble.body.setCircle(77, 31, 30);
      break;
    case "regular-sprite-nonsexist":
      bubble.body.setCircle(93, 15, 15);
      break;
    case "large-sprite-nonsexist":
      bubble.body.setCircle(108);
      break;
  }

  timeouts.push(
    setTimeout(() => {
      bubble.setGravity(gravityX, gravityY);
      scene.physics.world.enable(bubble);
      bubbles.push(bubble);
    }, index * timeout)
  );

  scene.bubblesArrayShuffled.shift();
}

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

function updateTimerText(self) {
  if (!self.time_up) {
    if (self.time_timer + 1000 <= self.scene.scene.time.now) {
      self.time_left -= 1;
      if (self.time_left <= 0) self.time_up = true;
      self.timer_text.text = self.time_left;
      self.time_timer = self.scene.scene.time.now;
    }
  } else {
    for (let i = 0; i < bubbles.length - 1; i++) {
      bubbles[i].destroy();
    }
    timeouts.forEach((timeout) => {
      clearTimeout(timeout);
    });
    time_up.setVisible(true);
    setTimeout(() => {
      music.stop();
      self.scene.stop();
      self.scene.start(CST.SCENES.ENDSCREEN, {
        User_ID: User_ID,
        points: points,
        nonSexistCount: nonSexistCount,
        sexistMissed: sexistMissed,
        nonSexistMissed: nonSexistMissed,
      });
    }, 3000);
  }
}
